export default {
    footer: {
        'li, button, h3, h2, h1, p': {
            listStyleType: 'none',
            color: 'var(--chakra-colors-black-300)',
            fontSize: '13px',
            fontWeight: 300,
            fontFamily: 'var(--chakra-fonts-inter)',
            lineHeight: '22px',
            letterSpacing: '.0040625rem',
            '@media screen and (max-width: 767px)': {
                fontSize: '.875rem'
            }
        },

        '.store-hour': {
            fontWeight: 400,
            marginBottom: '20px'
        },

        'li::marker': {
            content: "''"
        },

        h3: {
            color: 'var(--chakra-colors-black-300)',
            fontFamily: 'var(--chakra-fonts-inter)',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '25px',
            letterSpacing: '.005em',
            marginTop: '12px',
            marginBottom: '13px'
        },

        '.title-l': {
            margin: 0,
            padding: '0 0 11px 0',
            '@media screen and (min-width: 768px)': {
                borderBottom: '1px solid',
                borderColor: 'var(--chakra-colors-gray-550)',
                marginBottom: '11px'
            },
            '@media screen and (max-width: 767px)': {
                padding: '12px 15px'
            }
        },

        'div[data-id=yr-philanthropy-shine-bright-do-good], div[data-id=philanthropy-shine-bright-do-good]':
            {
                margin: '10px 0'
            },

        '.footer-links-title': {
            fontFamily: 'var(--chakra-fonts-inter)',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '25px'
        },

        '.footer-legal': {
            textAlign: 'center',
            ul: {
                display: 'inline-flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                maxWidth: '100%',
                width: 'fit-content'
            },
            a: {
                fontSize: '13px',
                fontWeight: 300,
                transition: 'all 0.3s ease',
                color: 'var(--chakra-colors-black-300)',
                '&:hover': {
                    color: 'var(--chakra-colors-blue-700)'
                }
            },
            '& > ul li ul li:after': {
                content: "'|'",
                padding: '0 20px 0 20px',
                '@media screen and (max-width: 767px)': {
                    display: 'none'
                }
            },
            '.ks-copy-right:before': {
                content: "'|'",
                paddingLeft: '20px',
                paddingRight: '20px',
                '@media screen and (max-width: 767px)': {
                    display: 'none'
                }
            },
            '.ks-copy-right, .ot-sdk-show-settings': {
                padding: '0 !important',
                border: 'none !important',
                color: 'var(--chakra-colors-black-300) !important',
                fontSize: '13px !important',
                transition: 'all 0.3s ease',
                '&:hover': {
                    color: 'var(--chakra-colors-blue-700) !important',
                    backgroundColor: 'transparent !important'
                },
                '@media screen and (max-width: 767px)': {
                    width: '100%'
                }
            },
            '.ks-copy-right': {
                cursor: 'default',
                fontWeight: 400
            }
        },

        '.social-icons-wrapper': {
            '.footer-icons': {
                width: '20px',
                height: '20px',
                display: 'inline-block',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat'
            },
            ul: {
                display: 'inline-flex'
            },
            li: {
                minWidth: 'unset',
                marginRight: '25px'
            },
            'li:last-child': {
                marginRight: '0px'
            },
            '.instagram-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/instagram-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/instagram-footer-hover-icon.svg)'
                }
            },
            '.facebook-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/facebook-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/facebook-footer-hover-icon.svg)'
                }
            },
            '.twitter-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/new-twitter-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/new-twitter-footer-hover-icon.svg)'
                }
            },
            '.pinterest-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/pinterest-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/pinterest-footer-hover-icon.svg)'
                }
            },
            '.tiktok-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/tiktok-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/tiktok-footer-hover-icon.svg)'
                }
            },
            '.youtube-footer-icon': {
                backgroundImage:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/youtube-footer-icon.svg)',
                '&:hover': {
                    backgroundImage:
                        'url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/youtube-footer-hover-icon.svg)'
                },
                width: '27.9px',
                height: '20px'
            }
        },

        '.yr-philanthropy-shine-bright-do-good-footer, .philanthropy-shine-bright-do-good-footer': {
            margin: '20px 0 20px',
            '.header': {
                fontFamily: 'var(--chakra-fonts-heading)',
                color: 'var(--chakra-colors-black-100)',
                fontSize: '23px',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '.115px',
                textTransform: 'none',
                marginTop: '10px',
                marginBottom: '10px'
            },
            '.description': {
                fontFamily: 'var(--chakra-fonts-inter)',
                color: 'var(--chakra-colors-black-100)',
                fontSize: '14px',
                fontWeight: 300,
                lineHeight: '22px',
                letterSpacing: '.07px',
                textTransform: 'none',
                margin: '0 0 10px 0'
            },
            a: {
                fontWeight: 300,
                textDecoration: 'underline',
                textUnderlineOffset: '4px'
            }
        }
    },

    '.list-track-content': {
        h1: {
            fontSize: '3rem',
            color: 'var(--chakra-colors-gray-670)',
            letterSpacing: '1px',
            fontFamily: 'var(--chakra-fonts-serif)',
            marginBottom: '10px',
            lineHeight: 1.2
        },
        h2: {
            fontSize: '1.25rem',
            color: 'var(--chakra-colors-gray-670)',
            margin: '0 0 20px',
            lineHeight: '28px',
            padding: '0 35px',
            fontFamily: 'var(--chakra-fonts-serif)'
        },
        p: {
            fontStyle: 'italic',
            fontFamily: 'var(--chakra-fonts-inter)',
            letterSpacing: '.005em',
            color: 'var(--chakra-colors-black-100)',
            fontSize: '1rem',
            lineHeight: '25px',
            fontWeight: 300,
            padding: '0 20px'
        },
        div: {
            letterSpacing: '1px',
            margin: '10px 0',
            fontSize: '.8125rem',
            lineHeight: '13px',
            textAlign: 'center',
            fontFamily: 'var(--chakra-fonts-serif)',
            color: 'var(--chakra-colors-black-100)'
        }
    },

    '@media (min-width: 768px)': {
        '.d-sm-none': {
            display: 'none !important'
        }
    },

    '@media screen and (max-width: 767px)': {
        footer: {
            '.collapse:not(.show)': {
                maxHeight: 0,
                overflow: 'hidden',
                transition: 'max-height 0.4s ease-out',
                padding: '0 15px'
            },
            'ul.show': {
                transition: 'max-height 0.4s ease-in',
                padding: '0 15px 15px 15px',
                maxHeight: '500px'
            },
            '.footer-title::after': {
                float: 'right',
                content: "' '",
                width: '15px',
                height: '15px',
                background:
                    'url(https://res.cloudinary.com/kendra-scott/image/upload/UIImages/images/redesign/arrow-default.svg) 50% center no-repeat !important',
                transform: 'rotate(90deg)',
                transition: 'all 0.3s ease',
                marginTop: '5px'
            },
            '.open-drawer::after': {
                transform: 'rotate(-90deg)',
                transition: 'all 0.3s ease'
            },
            '.footer-legal ul li.group ul li:first-of-type': {
                marginRight: '20px'
            }
        }
    }
}
